var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhotoByPhoto = function SvgPhotoByPhoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 29 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEF3C6",
    d: "M25.75 20.27V2.75H8.23v17.52zm0-20.04q.996 0 1.758.762t.762 1.758v17.52q0 .996-.762 1.757-.762.704-1.758.703H8.23q-.996 0-1.757-.703-.704-.761-.703-1.758V2.75q0-.996.703-1.758Q7.233.23 8.23.23zM3.25 5.27v19.98h19.98v2.52H3.25q-.996 0-1.758-.762T.73 25.25V5.27zm16.172 6.62 4.453 5.86h-13.77l3.457-4.395 2.461 2.93z"
  })));
};
export default SvgPhotoByPhoto;